import { render, staticRenderFns } from "./ScrollContainer.vue?vue&type=template&id=2b1e36a4&"
import script from "./ScrollContainer.vue?vue&type=script&lang=ts&"
export * from "./ScrollContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports